import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItemHeadline = function (props) {
    var notification = props.notification, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item-headline", { ref: ref, notification: notification ? (typeof notification === "string" ? notification : JSON.stringify(notification)) : undefined }, children));
};
export default VeltNotificationsPanelContentListItemHeadline;
